import React, {useContext, useEffect, useState} from "react";
import AccountImageContainer from "../AccountImageContainer";

import {
  StyledAccountImage,
  StyledActivityAddToFriendsImg, StyledActivityRemoveFriendImg,
  StyledActivitySendMessageImg,
  StyledActivitySendTipImg
} from "./styledClientDetails";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../../../App";
import ProfileActionsWindow from "../../../profileActionsWindow/ProfileActionsWindow";
import SendTipWindow from "../../../profileActionsWindow/SendTipWindow";
import ReactHintFactory from "react-hint";
import { useBetween } from "use-between";
import ProfileActionsStates from "../../../profileActionsWindow/ProfileActionsStates";
import http from "../../../../http";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import defaultImg from "../../../../assets/images/no-avatar.svg";
import {closableNotification} from "../../../elements/notification/ClosableNotification";

const ReactHint = ReactHintFactory(React);

const ClientDetailsMainInfo = ({ nickname }) => {

  const { t } = useTranslation("siteOptions");

  const {
    handleProfileActionsVisible,
    setVisibleTipWindow
  } = useBetween(ProfileActionsStates);

  const [activeNickname, setActiveNickname] = useState(null);
  const [isFriend, setIsFriend] = useState(false)
  const [room, setRoom] = useState(null);
  const { authenticated, user } = useContext(AppContext);

  const renderHint = (target) => {
    const { id, nickname, room } = target.dataset;
    setActiveNickname(nickname);
    setRoom(room);

    return <ProfileActionsWindow
      placement="friends"
      keys={+id}
      nickname={nickname}
    />;
  };

  const handleSendTip = () => {
    setActiveNickname(nickname);
    setVisibleTipWindow(true)
  }

  const [friends, setFriends] = useState([]);
  const friendsCount = friends.length;

  useEffect(() => {

    (async () => {
      try {
        const response = await http.get(
            "/api/user-friends",
            {
              ...userAuthenticationConfig(),
              params: {
                nickname: nickname
              }
            }
        );

        const friendsList = response.data['hydra:member'].map(item => ({
          nickname: item.userId2.nickname,
          level: 1,
          mediaObject: item.userId2.mediaObjectUrl ?? defaultImg
        }));

        setFriends(friendsList);
      } catch (e) {
        console.error('Failed to load friends', e);
      }
    })();

    (async () => {
      try {
        const response = await http.get(
            "/api/user_friends/check/" + nickname,
            {
              ...userAuthenticationConfig(),
            }
        );

        if(response.data?.isFriend === true){
          setIsFriend(true)
        }
      } catch (e) {
        console.error('Failed to load friend info', e);
      }
    })();

  }, []);

  const addToFriends = () => {
    http.post(
        "/api/user-friends",
        {nickname: nickname},
        { ...userAuthenticationConfig() }
    ).then(response => {
      closableNotification(t('add_friend_status.success'), 'success')
      setIsFriend(true)
    }).catch((error) => {
      if (error?.response?.status === 409) {
        // пользователь уже в друзьях
        closableNotification(t('add_friend_status.errorFriendExist'), 'error');
      } else {
        // любая другая ошибка
        closableNotification(t('add_friend_status.error'), 'error');
      }
    })
  }

  const removeFriend = () => {
    http.delete(
        "/api/user_friends/by-nickname/" + nickname,
        { ...userAuthenticationConfig() }
    ).then(response => {
      closableNotification(t('remove_friend_status.success'), 'success')
      setIsFriend(false)
    }).catch((error) => {
      if (error?.response?.status === 409) {
        // пользователь уже в друзьях
        closableNotification(t('remove_friend_status.errorFriendExist'), 'error');
      } else {
        // любая другая ошибка
        closableNotification(t('remove_friend_status.error'), 'error');
      }
    })
  }

  return (
    <StyledAccountImage>
      <ReactHint
        persist
        attribute="data-custom"
        className="custom-hint"
        onRenderContent={renderHint}
        events={{ click: true }}
      />
      {authenticated ? <SendTipWindow
        activeNickname={activeNickname}
        room={room}
      /> : null}
      <div className="user-info">
        <div style={{ position: 'relative' }}>
          <AccountImageContainer nickname={nickname}/>
          <div className="user-info__level" title={t('accountRating')}>
            ∞
          </div>
        </div>

        <div className="user-info__nickname">
          {nickname}
        </div>

        {
          authenticated && user?.nickname !== nickname ?
            <div className={'user-info__footer'}>
              {isFriend ? (
                  <button className={'remove-friend'} onClick={removeFriend}>
                    <StyledActivityRemoveFriendImg/>
                  </button>
              ):
                  <button className={'add-to-friends'} onClick={addToFriends}>
                    <StyledActivityAddToFriendsImg/>
                  </button>
              }
              <button className={'send-message'}>
                <StyledActivitySendMessageImg/>
              </button>
              {user.roles.includes('ROLE_MANAGER')?<button className={'send-tip'} onClick={handleSendTip}>
                <StyledActivitySendTipImg/>
              </button>:null}
            </div> :
            null
        }
      </div>
      <div className={'user-friends'}>
        <div className={'user-friends__title'}>
          <b>{friendsCount}</b> {t('friends')}
        </div>
        <div className={'user-friends__list' + (friendsCount === 0 ? ' empty' : '')}>
          {friends.length > 0 ? friends.map((friend, key) => (
            <div
              title={friend.nickname}
              className={'user-friends__list__item'}
              key={key}
              onClick={() => handleProfileActionsVisible(key, 'friends')}
              data-custom={true}
              data-custom-at="right"
              data-id={key}
              data-nickname={friend.nickname}
            >
              <img src={friend.mediaObject} alt={friend.nickname}/>
              <div className={'user-friends__list__item__level'}>{friend.level}</div>
            </div>
          )) : t('nobodysHere')}
        </div>
      </div>
    </StyledAccountImage>
  );
};

export default ClientDetailsMainInfo;